<template>
    <div id="app">
        <div class="container-fluid">
            <div class="row">
                <div class="col menu-slot">
                    <menu-component></menu-component>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <router-view :config="getConfig()"> </router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import immoMenu from './components/MenuComponent.vue'
import cfg from './assets/data/siteconfig.js'

export default {
    name: 'app',
    metaInfo: {
        title: 'IMMOCOACH',
        meta: [
            {
                name: 'viewport',
                content: 'width=device-width, initial-scale=0.5'
            },
            {
                name: 'keywords',
                content:
                    'Planung, Projekt- & Beschaffungsmanagement. GU. Generalplanung. Realisierung von Industrie-, Logistik- und Recyclingbauten. Recycling. Wertstoffsammelstelle' +
                    'Sammelstelle. swico. sens. Architekt. Grossprojekte. '
            },
            {
                name: 'description',
                content:
                    'Die Immocoach AG entwickelt, plant und realisiert Industrie-, Logistik- und im speziellen Recyclingbauten.'
            },
            {
                name: 'theme-color',
                content: '#00589A'
            }
        ],
        htmlAttrs: {
            lang: 'de'
        }
    },
    components: {
        'menu-component': immoMenu
    },
    created: function() {
        // if ('serviceWorker' in navigator) {
        //     window.addEventListener('load', () => {
        //         navigator.serviceWorker.register('/sw.js').then(registration => {
        //             console.log('SW registered: ', registration)
        //         }).catch(registrationError => {
        //             console.log('SW registration failed: ', registrationError)
        //         })
        //     })
        // }
    },
    methods: {
        getConfig() {
            return cfg
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles/main.scss';

@font-face {
    font-family: 'miso-light';
    src: url('./assets/fonts/miso/miso-light-webfont.woff2') format('woff2'),
        url('./assets/fonts/miso/miso-light-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'miso-bold';
    src: url('./assets/fonts/miso/miso-bold-webfont.woff2') format('woff2'),
        url('./assets/fonts/miso/miso-bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 36px;
}

.menu-slot {
    padding-left: $main-indent;
    padding-right: $main-indent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue